import { _ } from "libs";
import React from "react";
import { WaitingReservation } from "../../../types";
import moment from "moment-timezone";
import { Link } from "react-router-dom";

const WaitingReservationItemLarge = ({
	waitingReservation,
	onDeleteClick,
	extra = "",
}: {
	waitingReservation: WaitingReservation;
	onDeleteClick: (uuid: string) => void;
	extra?: string;
}) => {
	const reservation = waitingReservation.reservation;
	const timezone = reservation.club.clubInfo.timeZone;
	const date = moment.unix(reservation.startDateTime).tz(timezone);

	const { club, court } = reservation;
	const sport = court.sport;
	return (
		<div className={`item reservation large waiting ${extra}`} data-number-of-partners="0">
			<div className="remove clickable" onClick={onDeleteClick.bind(null, reservation.reservationId)}></div>
			{waitingReservation.available && (
				<div style={{ marginBottom: "10px" }}>
					<span className="badge available">{_("waitingList.available")}</span>
				</div>
			)}
			<div className="horizontal">
				<div className="date">
					<div className="dateDay">{date.format("D")}</div>
					<div className="dateMonth">{date.format("MMM")}</div>
				</div>
				<div className="itemBody">
					<div className="title">
						{date.format("HH:mm")} at {club.clubInfo.name}
					</div>
					<div className="meta">{court.name}</div>
				</div>
			</div>
			{waitingReservation.available && (
				<Link
					className="button small"
					style={{ marginTop: "10px" }}
					to={`/club/${club.clubInfo.clubId}?timestamp=${date.unix()}&court=${court.courtId}`}
				>
					{_("waitingList.createReservation")}
				</Link>
			)}
		</div>
	);
};

export default WaitingReservationItemLarge;
